module.exports = __webpack_public_path__ + "img/例外包装件(放射).0d834151.jpg";